<template>
   <el-dialog
        title="添加管理员"
        :visible.sync="addDialogVisible"
        width="50%"
        @close="addDialogClosed"
        >
          <el-form
          ref="addFormRef" label-width="90px" :model="addForm" :rules="rules">
              <el-form-item label="账号名" prop="username">
                  <el-input v-model="addForm.username"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="password" >
                  <el-input type='password' v-model="addForm.password"></el-input>
              </el-form-item>
              <el-form-item label="姓名" prop="realName">
                  <el-input v-model="addForm.realName"></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="phone">
                  <el-input v-model="addForm.phone"></el-input>
              </el-form-item>
          </el-form>
          <!-- 底部区域 -->
          <span slot="footer" class="dialog-footer">
              <el-button @click="addDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addUser">确 定</el-button>
          </span>
        </el-dialog>
</template>

<script>
import * as api from '@/api/platform/admin'
export default {
    data() {
      // 验证真实姓名的规则
      // var checkRealname = (rules, value, cr) => {
      //   // 验证真实姓名的正则表达式
      //   const realnameReg = /^[\u4E00-\u9FA5]{2,10}(·[\u4E00-\u9FA5]{2,10}){0,2}$/
      //   if (realnameReg.test(value)) {
      //     return cr()
      //   }
      //   cr(new Error('请输入真实姓名'))
      // }
      return {
        rules: {
          username: [{ required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在1 到 10 个字符之间', trigger: 'blur' }],
          password: [{ required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, max: 15, message: '长度在5 到 15 个字符之间', trigger: 'blur' }],
          realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
          phone: [{ required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: this.$valid.checkPhone, trigger: 'blur' }]
        },
        addDialogVisible: false,
        addForm: {
          username: '',
          password: '',
          realName: '',
          phone: ''
        }
      }
    },
    methods: {
      // 添加管理员
     addUser () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        api.addUser(this.addForm).then(res => {
          this.addDialogVisible = false
          this.$message.success('创建平台管理员成功！')
          this.$parent.getPlatformAdminList()
        })
      })
    },
    show() {
      this.addDialogVisible = true
    },
    addDialogClosed () {
      this.$refs.addFormRef.resetFields()
    }
    }

}
</script>

<style>

</style>
